<h1 mat-dialog-title>{{ 'DELETE-INSIDE-FIELD-DIALOG.TITLE' | translate }}</h1>
<div mat-dialog-content>
    <p>{{ 'DELETE-INSIDE-FIELD-DIALOG.FILL-SPACE' | translate }}</p>
</div>
<div mat-dialog-actions>
    <button class="delete-inside-field-btn" mat-flat-button (click)="deleteSpace()">{{ 'DELETE-ALL-PINS-DIALOG.YES' | translate }}</button>
    <button class="delete-inside-field-btn" mat-flat-button (click)="cancel()">{{ 'DELETE-ALL-PINS-DIALOG.NO' | translate }}</button>
</div>
